<ion-content class="ion-padding">


    <img src="/assets/images/logo-dashboard.png"
         class="logo"
         alt="" />

    <div [innerHtml]="'DEEPLINK_HEADER' | translate"></div>

    <ion-button (click)="downloadApp()"
                color="secondary">
        {{'DEEPLINK_DOWNLOAD_APP' | translate}}
    </ion-button>

    <ion-button (click)="openWeb()"
                color="secondary">
        {{'DEEPLINK_OPEN_WEB' | translate}}
    </ion-button>

    <div [innerHtml]="'DEEPLINK_INFO' | translate"></div>

</ion-content>